export enum ContextMenuItemStateCommandCriteria {
  /** Command evaluates every selected item, menu item state and menu state */
  Item,
  /** Command evaluates only menu item state and menu state */
  MenuItem,
  PostItem,
}
